import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CanActivateChildGuard implements CanActivate {
  checkArray: any = [
    'main',
    'enterprise',
    'customers',
    'add-customer',
    'update-customer',
    'view-customer',
    'branches',
    'add-branch',
    'update-branch',
    'user',
    'user-group',
    'search-document',
    'search-document-sign',
    'search-document-receive',
    'digital-contract',
    'add-document',
    'digital-certificate',
    'document-type',
    'add-document-type-list',
    'update-document',
    'notify',
    'total-contract-report',
    'sms-quantity-report',
    'sms-money-report',
    'contract-enterprise-create',
    'contract-personal-create',
    'contract-enterprise-receive',
    'add-document-group-v2',
    'synchronize-document-group',
    'import-customer',
    'add-user-group',
    'import-user',
    'contract-digitzation-moha',
    'search-document-contract-company',
    'approved-contract-moha',
    'document-approved-contract',
  ];

  constructor(
    private router: Router
  ) { }

  canActivate(activatedRoute: ActivatedRouteSnapshot) {
    const routerArray = window.location.pathname.split('/');
    let role: any = JSON.parse(localStorage.getItem('permissions'))
    // MANAGE_CUSTOMER = 4
    // MANAGE_ENTERPRISE = 1,
    // MANAGE_USER = 2,
    if(localStorage.getItem('isFromSSO') =='true'){
        routerArray.forEach(e => {
          if (e == 'add-customer' || e == 'import-customer' || e == 'update-customer') {
            this.router.navigate(['/page-not-found']);
            return false;
          }
        })
      //
      if (( role.includes(2))) {
        routerArray.forEach(e => {
          if (e == 'add-user-group' || e == 'import-user') {
            this.router.navigate(['/page-not-found']);
            return false;
          }
        })
      }
    }
    if (this.checkArray.includes(routerArray[1])) {
      this.router.navigate(['/page-not-found']);
      return false;
    }
    return true;
  }
}
